import { render, staticRenderFns } from "./loading-dots.vue?vue&type=template&id=37c01a23&scoped=true"
import script from "./loading-dots.vue?vue&type=script&lang=js"
export * from "./loading-dots.vue?vue&type=script&lang=js"
import style0 from "./loading-dots.vue?vue&type=style&index=0&id=37c01a23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c01a23",
  null
  
)

export default component.exports